import React from "react";
import "./NoResult.css";

export default function NoResult() {
  return (
    <div className="no-result">
      <span>404</span>
    </div>
  );
}
